import { createSelector } from '@reduxjs/toolkit';
import { selectLatestDataset } from '../../components/Map/useDeckGL/Axon/useAxonGLNext';
import { AXON } from './constants';

/**
 * Memoized selector for Axon data formatted for search.
 * Only recalculates when the axon datasets actually change.
 */
const selectAxon = createSelector(
  [state => state.axon?.datasets, state => selectLatestDataset(state)],
  (datasets, dataset) => {
    if (!datasets || !Object.keys(datasets).length) {
      return null;
    }

    let searchableAxonMarkers = [];
    if (dataset) {
      searchableAxonMarkers = Object.values(dataset).map(ds => ({
        ...ds,
        source: AXON,
        _badgeNumber: ds.attributes?.officer?.badge_number,
        _lastName: ds.attributes?.officer?.last_name,
        _firstName: ds.attributes?.officer?.first_name,
        _fullName: ds.attributes?.officer?.full_name,
      }));
    }

    return {
      keys: ['_badgeNumber', '_lastName', '_firstName', '_fullName'],
      data: searchableAxonMarkers,
    };
  },
);

export default selectAxon;
